var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, Inject, Vue } from "vue-property-decorator";
import { TEN_SECONDS } from "@common/communication";
let default_1 = class default_1 extends Vue {
    constructor() {
        super(...arguments);
        this.data = null;
    }
    mounted() {
        this.load();
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            this.data = yield post("/api/Merchant/Edit");
            // console.log(this.data);
        });
    }
    copy() {
        if (!this.data)
            return;
        this.data.AdministratorContact.Name = this.data.LiaisonContact.Name;
        this.data.AdministratorContact.Phone = this.data.LiaisonContact.Phone;
        this.data.AdministratorContact.Email = this.data.LiaisonContact.Email;
    }
    send() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield post('/api/Merchant/Update', Object.assign({}, this.data));
            if (result) {
                yield this.alert('已發送驗證信到「' + this.data.Email + '」，請前往收信，並點擊信中驗證連結，以完成信箱驗證。', '驗證信已送出', 'warning');
            }
            else {
                yield this.alert('修改成功', undefined, 'success');
            }
            this.$router.back();
        });
    }
    resend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.data)
                return;
            if (!(yield this.$refs.email.valid()))
                return;
            yield post('/api/Merchant/Resend', { Email: this.data.Email }, TEN_SECONDS);
            yield this.alert('已發送驗證信到「' + this.data.Email + '」，請前往收信，並點擊信中驗證連結，以完成信箱驗證。', '驗證信已送出', 'warning');
        });
    }
};
__decorate([
    Inject()
], default_1.prototype, "alert", void 0);
default_1 = __decorate([
    Component
], default_1);
export default default_1;
